import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basicTimerMsg } from '../../../../actions/swal_msg';
import { blogCategorySelected, deleteBlogCategory, saveBlogCategory } from '../../../../actions/admin/blog';

import './BlogCategory.css';

import {
    Grid, Stack, TextField, IconButton, Box, Chip, Button
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';

const BlogCategory = () => {
    const dispatch = useDispatch();
    const { blog: { categories } } = useSelector(state => state.blog);

    const [category, setCategory] = useState('');
    
    // campo categoría
    const handleOnChange = ({ target }) => {
        setCategory(target.value);
    };

    // guardar categoría
    const saveCategory = () => {
        if (category.length > 1 && category.length <= 100)
            dispatch(saveBlogCategory(category, setCategory));
        else basicTimerMsg('Ingrese nombre de categoría');
    };

    // categoría seleccionada
    const handleToggle = category_id => () => {
        dispatch(blogCategorySelected(
            categories.map(
                e => e._id === category_id ? { ...e, checked: !e.checked } : e
            )
        ));
    };

    const [enabledManagement, setEnableManagement] = useState(false);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
                    {categories.map(({ _id, category, checked }) => {
                        return (
                            <Chip
                                key={_id}
                                label={category}
                                onClick={handleToggle(_id)}
                                onDelete={
                                    enabledManagement ? () => dispatch(deleteBlogCategory(_id)) : undefined
                                }
                                sx={[
                                    {
                                        '&:hover': {
                                            backgroundColor: checked ? '#1f618d' : '#ccd1d1',
                                            color: checked ? '#fff' : '#000'
                                        },
                                    },
                                    {
                                        '& .MuiChip-deleteIcon': {
                                            color: checked ? '#fff' : 'none'
                                        },
                                        '& .MuiChip-deleteIcon:hover': {
                                            color: checked ? '#ecf0f1' : 'none'
                                        },
                                    },
                                    { backgroundColor: checked ? '#2471a3' : 'none', color: checked ? '#fff' : '#000', }
                                ]}
                            />
                        );
                    })}
                </Box>
                {
                    enabledManagement !== false &&
                        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                            <TextField fullWidth
                                variant='outlined'
                                label="Nueva categoría"
                                size='small'
                                name='category'
                                inputProps={{ maxLength: 100 }}
                                value={category}
                                onChange={handleOnChange}
                            />
                            <IconButton aria-label="add"
                                onClick={saveCategory}>
                                <AddIcon />
                            </IconButton>
                        </Stack>
                }
                <Button onClick={() => { setEnableManagement(!enabledManagement) }}
                    endIcon={!enabledManagement && <SettingsIcon />}
                    sx={{ mt: 1, textTransform: 'none' }}>
                    {enabledManagement === false ? 'Gestionar categorias' : 'Cancelar'}
                </Button>
            </Grid>
        </Grid>
    );
};

export default BlogCategory;